import { useLang } from "@/context/LanguageContext";
import { contactInfo } from "@/data/content";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="border-t border-zinc-800 bg-zinc-950">
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-6 py-12 sm:px-12 md:flex-row md:items-center md:justify-between">
        <div>
          <div className="font-heading text-xl font-semibold text-white">Angelo Zaia</div>
          <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">
            {t.footer.tagline}
          </div>
        </div>
        <div className="flex flex-col gap-1 text-sm text-zinc-500 md:items-end">
          <a href={`mailto:${contactInfo.email}`} className="transition-colors hover:text-white">
            {contactInfo.email}
          </a>
        </div>
      </div>
      <div className="border-t border-zinc-900 px-6 py-6 sm:px-12">
        <p className="mx-auto max-w-7xl font-mono text-[10px] uppercase tracking-[0.15em] text-zinc-600">
          © {year} Angelo Zaia — {t.footer.rights}
        </p>
      </div>
    </footer>
  );
};
